<div class="p-3">
  <nk-shared-card-user-box
    resumeTitle="Penting gak Penting yang oentung Posting"
    name="John Doe"
    [allStats]="true"
    [status]="avatarEnum.person"
  ></nk-shared-card-user-box>
</div>
